import React from "react";
import PropTypes from "prop-types";
import FadedScrollableText from "./FadedScrollableText";

import "apps/messenger/components/Connections/shared/Essay.scss";

function Essay({ title, clean_content: cleanContent }) {
	return (
		<div className="connection-scrollable-essay">
			<FadedScrollableText>
				<div className="connection-scrollable-essay-content">
					<div
						className="connection-scrollable-essay-content-title"
					>
						{title}
					</div>
					<div
						className="connection-scrollable-essay-content-essay"
						dangerouslySetInnerHTML={{ __html: cleanContent }}
					/>
				</div>
			</FadedScrollableText>
		</div>
	);
}

Essay.propTypes = {
	title: PropTypes.string,
	clean_content: PropTypes.string,
};

export default Essay;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/shared/Essay.jsx